




















































import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';
import { BAlert } from 'bootstrap-vue';
import ZenMultiselect from '@reciprocity/multiselect';
import { cloneDeep } from 'lodash';
import { ZenFormGroup } from 'zenComponents';
import { Alert } from '@/components/global_alerts/types';
import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';
import { Vector } from '@/pages/risk_settings/types';

export interface VectorPair {
  x: Vector;
  y: Vector;
}

export default Vue.extend({
  name: 'HeatmapEditVectorCard',
  components: {
    GenericCard,
    ZenMultiselect,
    ZenFormGroup,
    BAlert,
  },
  directives: {},
  props: {
    saveUrl: {
      type: String,
      default: '',
    },
    vectors: {
      type: Array as () => Vector[],
      default: '',
    },
    vectorPair: {
      type: Object as PropType<VectorPair>,
      default: () => ({ x: {}, y: {} }),
    },
    scoreTitle: {
      type: String,
      default: '',
    },
    axe: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: <boolean>false,
      saving: <boolean>false,
      myVectorPair: { x: {}, y: {} },
      alerts: <Alert[]>[],
    };
  },
  watch: {
    vectorPair: {
      handler(value) {
        this.myVectorPair = cloneDeep(value);
        if (this.axe) {
          this.originalValue = cloneDeep(value[this.axe]);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.changeModalSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
      showAlert: 'alerts/show',
      request: 'request',
    }),
    async save() {
      if (this.axe && this.myVectorPair.x.id === this.myVectorPair.y.id) {
        let contraProp = this.axe === 'x' ? 'y' : 'x';
        this.myVectorPair[contraProp] = this.originalValue;
      }

      this.saving = true;
      try {
        await this.request({
          method: 'put',
          url: this.saveUrl,
          data: {
            heatmapX: this.myVectorPair.x.id,
            heatmapY: this.myVectorPair.y.id,
          },
          defaultErrorHandler: false,
        });
      } catch (errors) {
        this.alerts = [errors.response.data];
      } finally {
        this.saving = false;
      }
      this.showAlert({
        type: 'success',
        message: 'Defaults successfully updated',
      });
      this.confirmModal();
    },
    onChange(value, prop) {
      let current = this.myVectorPair;

      if (value.id === current[prop].id) return;

      let contraProp = prop === 'x' ? 'y' : 'x';
      let switchXY = !this.axe && value.id === current[contraProp].id;
      if (switchXY) {
        current[contraProp] = current[prop];
      }

      current[prop] = cloneDeep(value);
    },
  },
});
